export const NOT_DEFINED_DELIVERY_CARRIER_ID = 'not_defined_carrier';
export const DEFAULT_VISIBLE_TRACKING_VIEW_LENGTH = 3;
